import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useAuth } from "@/hooks/useAuth";
import API from "@/config/api";
import type { AuthProvider } from "@/types/auth";
import type { User } from "@/types/user";
import showMutationError from "@/lib/showMutationError";
import useReturnTo from "../useReturnTo";

export type SocialLoginPayload = {
  providerId: AuthProvider["id"];
  code?: string;
  credential?: string;
  oneTapFlag?: string;
};

type SocialLoginResponse = {
  user: User;
  message: string;
};

const loginWithSocialProvider = async (
  payload: SocialLoginPayload,
): Promise<SocialLoginResponse> => {
  const response = await API.main.post<SocialLoginResponse>(
    `/auth/social/login?${payload?.oneTapFlag}=true`,
    payload,
  );

  return response.data;
};
interface SocialLoginOptions {
  onSuccessReturnTo: boolean;
}
export default function useSocialLogin({
  onSuccessReturnTo = true,
}: SocialLoginOptions) {
  const { returnTo } = useReturnTo();
  const { refresh } = useAuth();

  return useMutation({
    mutationFn: loginWithSocialProvider,
    onSuccess: async (data) => {
      await refresh?.();
      if (onSuccessReturnTo) {
        returnTo();
      }
      toast.success(data?.message || "Social login success!");
    },
    onError: showMutationError("Social login fail!"),
  });
}
